<template>
  <div v-if="$props.item && $props.item.type == 'CERTIFICATE'">
    <div class="container" v-if="hasCertificate()">
      <div class="row">
        <div class="col-sm pdf-display">
          <pdf-viewer
            :key="$props.item.id"
            :pdfData="this.fileBase64"
            :loading="this.loading"
          >
          </pdf-viewer>
        </div>
      </div>
    </div>

    <div id="align-step-center div-certificate">
      <p
        class="T15 certificate-text text-center"
        v-if="!loading && !hasCertificate()"
      >
        {{ certificateNotAvailableText }}
      </p>
      <div class="row" v-if="loading">
        <div class="col-sm pdf-display">
          <b-skeleton-img no-aspect height="405px"></b-skeleton-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadCertificate } from "../../../services/training/trainingService.js";
import PdfViewer from "../../../components/pdf-viewer/PdfTrainingViewer.vue";
import { createToast } from "../../../components/toast/toast";

export default {
  props: ["onFinishedStep", "onStartStep", "item"],
  components: {
    PdfViewer,
  },
  mounted() {
    this.downloadCertificate(this.$props.item);
  },
  watch: {
    item: {
      async handler(val) {
        if (val?.type == "CERTIFICATE") {
          await this.$props.onStartStep(val);
          this.$props.onFinishedStep(val);
          await this.downloadCertificate(val);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      fileBase64: null,
      loading: false,
      certificateNotAvailableText: "",
    };
  },
  methods: {
    hasCertificate() {
      return this.fileBase64 != null && !this.loading;
    },
    async downloadCertificate(item) {
      if (!item || !item.idTraining) {
        return;
      }
      this.loading = true;

      try {
        const response = await downloadCertificate(item.idTraining);

        if (!response && response.fileBase64) {
          this.loading = false;
          this.fileBase64 = null;
          this.certificateNotAvailableText =
            "Seu certificado ainda não está disponível! Aguarde, em breve disponibilizaremos para você.";
          return;
        }

        this.fileBase64 = response.fileBase64;
        this.loading = false;
        if (!this.fileBase64) {
          this.certificateNotAvailableText =
            "Seu certificado ainda não está disponível! Aguarde, em breve disponibilizaremos para você.";
        } else {
          this.certificateNotAvailableText = "";
        }
      } catch (error) {
        createToast("Erro", "Não foi possível baixar o certificado.");
        console.error(
          "Error onDownloadCertificate: error ao baixar o certificado",
          error
        );
        this.loading = false;
        this.certificateNotAvailableText =
          "Seu certificado ainda não está disponível! Aguarde, em breve disponibilizaremos para você.";
      }
    },
    onStepDownloadCertificateClick(step) {
      this.stepSelected = step;
      this.$props.onFinishedStep(step);
    },
  },
};
</script>
<style lang="scss" scoped>
.certificate-text {
  color: #23272b;
  font-size: 16px;
}
.align-step-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
